import { Container, Grid } from "@mui/material";
import { useAppSelector } from "app/hooks";
import Header from "components/header/Header";
import { selectCustomerPurchase } from "features/customer/customerSlice";
import formatDate from "hooks/useDate";
import { CustomerPurchaseInterface } from "interfaces/CustomerPurchaseInterface";
import InvoiceLotList from "./InvoiceLotList";

// const dispatch = useAppDispatch();
// const { login_and_validation_required} = clientInformation

export default function InvoiceOverview() {
  const purchaseData = useAppSelector(selectCustomerPurchase) as CustomerPurchaseInterface
  return (
    <Container sx={{ pt: 4, pb: 4 }}>
      <Grid container>
        <Header header={`Rechnung vom ${formatDate(purchaseData.created_at)}`} backButton />
        <InvoiceLotList />
      </Grid>
    </Container>
  );
}
